import { Environments } from '@/config';
import { HELIX_OSUWMC_PRODUCTION } from './helix-osuwmc.production';
import { HELIX_OSUWMC_STAGING } from './helix-osuwmc.staging';

export const HELIX_OSUWMC = import.meta.env.MODE === Environments.PROD ? HELIX_OSUWMC_PRODUCTION : HELIX_OSUWMC_STAGING;
